<template>
  <a-modal
    :visible="visible"
    :title="null"
    @cancel="handleCancel"
    :footer="null"
    width="900px"
  >
    <div class="modal-content">
      <h1 class="page-title">센터플로우 협력업체 정산 가격표</h1>
      
      <!-- 센터플로우 정산 가격표 테이블 -->
      <h3 class="table-title">센터플로우 정산 가격</h3>
      <div class="table-responsive">
        <a-table class="ant-table-striped"
                 size="small"
                 bordered
                 :scroll="{ x: '800px' }"
                 :columns="liquidationColumns"
                 :data-source="liquidationData"
                 :pagination="false"
        >
        </a-table>
      </div>
      
      <!-- 대행업체 정산가 테이블 -->
      <h3 class="table-title">대행업체 정산가</h3>
      <div class="table-responsive">
        <a-table class="ant-table-striped"
                 size="small"
                 bordered
                 :scroll="{ x: '800px' }"
                 :columns="agencyColumns"
                 :data-source="agencyData"
                 :pagination="false"
        >
        </a-table>
      </div>
      
      <div class="modal-footer">
        <a-button @click="handleCancel">닫기</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "CenterflowSettlementRatesModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 청산가 테이블 데이터
      liquidationColumns: [
        { title: '항목', dataIndex: 'item', key: 'item', align: 'center', width: 200 },
        { title: '정산가(VAT제외)', dataIndex: 'priceExcludingVAT', key: 'priceExcludingVAT', align: 'right', width: 150,
          customRender: ({text}) => `${text.toLocaleString()}` },
        { title: '정산가(VAT포함)', dataIndex: 'priceIncludingVAT', key: 'priceIncludingVAT', align: 'right', width: 150,
          customRender: ({text}) => `${text.toLocaleString()}` },
        { title: '내용', dataIndex: 'description', key: 'description', align: 'left', width: 250 }
      ],
      liquidationData: [
        { key: '1', item: '센터플로우 상품가', priceExcludingVAT: 240000, priceIncludingVAT: 264000, description: '센터플로우 상품 가격' },
        { key: '2', item: '부가서비스 사용료', priceExcludingVAT: 5000, priceIncludingVAT: 5500, description: '비즈메시지 등 부가서비스가' }
      ],
      
      // 대행업체 정산가 테이블 데이터
      agencyColumns: [
        { title: '업체명', dataIndex: 'companyName', key: 'companyName', align: 'center', width: 150 },
        { title: '설치비(1회성)', dataIndex: 'price', key: 'price', align: 'right', width: 150,
          customRender: ({text}) => `${text.toLocaleString()}` },
        { title: '영업비(월별 정산)', dataIndex: 'salesFee', key: 'salesFee', align: 'right', width: 150,
          customRender: ({text}) => `${text.toLocaleString()}` },
        { title: '내용', dataIndex: 'description', key: 'description', align: 'left', width: 250 }
      ],
      agencyData: [
        { key: '1', companyName: 'IOT시스템', price: 1500000, salesFee: 0, description: '부산/경남지역 지과 영업' },
        { key: '2', companyName: '리뉴메디컬', price: 1500000, salesFee: 0, description: '서울/수도권 치과 영업' },
        { key: '3', companyName: '메디라이크', price: 1500000, salesFee: 0, description: '피부과/성형외과 영업' },
        { key: '4', companyName: '감탄치과', price: 0, salesFee: 40000, description: '' },
        { key: '5', companyName: '직계약', price: 0, salesFee: 0, description: '' }
      ]
    };
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped lang="scss">
.modal-content {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #000;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 16px;
  color: #333;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}
</style>
